// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2N2IN","containerItemsCenter":"Skeleton_containerItemsCenter__o1EyM"};